import { DateRange } from 'src/transaction-search/interfaces/get-effective-return-policy-response';
import { SearchTransactionsResponse } from 'src/transaction-search/interfaces/transaction-search-response';

export interface ITransactionSearchState {
  dateRange: DateRange;
  posNumber?: string;
  storeNumber?: string;
  transactionNumber?: string;
  transactionList?: SearchTransactionsResponse;
  isSearchResultView?: boolean;
  itemCode?: string;
  customerId?: string;
  isVoided?: boolean;
  isSuspended?: boolean;
  pageNumber?: number;
  pageSize?: number;
  loyaltyCard?: string;
  searchContext: TransactionSearchContext;
}

export enum TransactionSearchContext {
  TBR = 'TBR',
  ReprintReceipt = 'Reprint Receipt',
}
